/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiply the price by the discount percentage divided by 100 to get the amount saved, then subtract it from the price.`)
};

const es_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplica el precio por el porcentaje de descuento dividido entre 100 para obtener la cantidad ahorrada, y réstala del precio.`)
};

const de_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliziere den Preis mit dem Rabatt-Prozentsatz geteilt durch 100, um den Sparbetrag zu erhalten, und ziehe ihn dann vom Preis ab.`)
};

const nl_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermenigvuldig de prijs met het kortingspercentage gedeeld door 100 om het bespaarde bedrag te krijgen, en trek dat vervolgens van de prijs af.`)
};

const fr_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliez le prix par le pourcentage de réduction divisé par 100 pour obtenir le montant économisé, puis soustrayez-le du prix.`)
};

const it_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moltiplica il prezzo per la percentuale di sconto divisa per 100 per ottenere l'importo risparmiato, poi sottrailo dal prezzo.`)
};

const pt_br2_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique o preço pela porcentagem de desconto dividida por 100 para obter o valor economizado, depois subtraia esse valor do preço.`)
};

const pt_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique o preço pela percentagem de desconto dividida por 100 para obter o valor poupado, depois subtraia-o ao preço.`)
};

const ja_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格に割引率を100で割った値を掛けて節約額を求め、それを価格から引きます。`)
};

const zh_pct_discount_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用价格乘以折扣比例除以 100 得到节省金额，再从价格中减去该金额。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_faq1_a", locale)
	if (locale === "en") return en_pct_discount_faq1_a(inputs)
	if (locale === "es") return es_pct_discount_faq1_a(inputs)
	if (locale === "de") return de_pct_discount_faq1_a(inputs)
	if (locale === "nl") return nl_pct_discount_faq1_a(inputs)
	if (locale === "fr") return fr_pct_discount_faq1_a(inputs)
	if (locale === "it") return it_pct_discount_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_faq1_a(inputs)
	if (locale === "pt") return pt_pct_discount_faq1_a(inputs)
	if (locale === "ja") return ja_pct_discount_faq1_a(inputs)
	return zh_pct_discount_faq1_a(inputs)
};